import React from 'react'
import withQueryParams from 'components/withQueryParams'
import SupportButton from './components/SupportButton'
import styled from 'react-emotion'

const Center = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 75vh;
  padding: 0 1rem;
`

const Prompt = styled.h6`
  margin: 2rem 0;
`

const RouteErrorsDynamic = ({ query }) => (
  <Center>
    <h3>Looks like we're experiencing an issue. Let's solve that!</h3>
    <Prompt>Please reach out to us by clicking below:</Prompt>
    <SupportButton
      kind="standard"
      platformId={query.get('platformId')}
      error={query.get('error') || 'Unknown Error'}
    />
  </Center>
)

export default withQueryParams(RouteErrorsDynamic)



// WEBPACK FOOTER //
// ./src/routes/errors/dynamic.js